"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVariableNode = exports.processSelection = exports.processInline = exports.processBlock = exports.deserialiseNode = exports.deserialise = void 0;
var lodash_1 = require("lodash");
var Utils_1 = require("../Utils");
var SideBySide_1 = require("ContentTokens/DataModels/SideBySide");
var Common_1 = require("ContentTokens/Models/Common");
var Table_1 = require("ContentTokens/DataModels/Table");
var Text_1 = require("ContentTokens/Models/Text");
var SideBySide_2 = require("ContentTokens/Models/SideBySide");
var MediaVariable_1 = require("ContentTokens/DataModels/MediaVariable");
var ContentLoop_1 = require("ContentTokens/DataModels/ContentLoop");
var DeserialiseErrorRecorder_1 = require("./DeserialiseErrorRecorder");
var mobx_1 = require("mobx");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var deserialise = function (tokens) {
    tokens = (0, mobx_1.toJS)(tokens);
    var commentTracker = {};
    var nodesAndSelection = (0, exports.deserialiseNode)(tokens, commentTracker);
    return nodesAndSelection;
};
exports.deserialise = deserialise;
var deserialiseNode = function (tokens, commentTracker) {
    var content = {
        children: [],
    };
    var currentBlock = null;
    var lastNode = null;
    var processedAnchor = null;
    for (var t = 0; t < tokens.length; t++) {
        var token = tokens[t];
        switch (token.type) {
            case "block":
                if (currentBlock != null) {
                    addBlockToContent(content, currentBlock);
                }
                currentBlock = (0, exports.processBlock)(token, content, commentTracker);
                lastNode = currentBlock;
                break;
            case "inline":
                if (currentBlock == null) {
                    break;
                }
                var newNode = (0, exports.processInline)(token, commentTracker);
                if (nodesCanMerge(lastNode, newNode)) {
                    mergeNodeInto(lastNode, newNode);
                }
                else {
                    currentBlock.children.push(newNode);
                    lastNode = newNode;
                }
                break;
            case "selection":
                (0, exports.processSelection)(token, content, lastNode, currentBlock, tokens[t + 1]);
                if (token.subType == "anchor") {
                    processedAnchor = true;
                }
                else if (!processedAnchor) {
                    content.selection.isBackward = true;
                }
                break;
            case "comment":
                if (token.subType === "start") {
                    commentTracker[token.id] = token;
                }
                else if (token.subType == "end") {
                    delete commentTracker[token.id];
                }
                break;
            default:
                throw new Error("invalid token ".concat(token.type));
        }
    }
    if (currentBlock != null) {
        addBlockToContent(content, currentBlock);
    }
    return content;
};
exports.deserialiseNode = deserialiseNode;
var addBlockToContent = function (content, currentBlock) {
    if (currentBlock.children.length === 0 && currentBlock.type !== Common_1.BlockType.Table) {
        currentBlock.children.push({
            text: "",
            marks: [],
        });
    }
    content.children.push(currentBlock);
};
var processBlock = function (token, content, commentTracker) {
    var _a;
    var deserialisedFromRegistry = (_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(token.subType)) === null || _a === void 0 ? void 0 : _a.deserialise(token, content, commentTracker);
    if (deserialisedFromRegistry) {
        return deserialisedFromRegistry;
    }
    var currentBlock = {
        type: token.subType,
        children: [],
        data: {},
        isVoid: false,
    };
    switch (token.subType) {
        case Common_1.BlockType.Caption:
            currentBlock.type = Common_1.BlockType.Paragraph;
        case Common_1.BlockType.Paragraph:
            break;
        case Common_1.BlockType.Heading1:
            break;
        case Common_1.BlockType.Heading2:
            break;
        case Common_1.BlockType.BlockQuote:
            break;
        case Common_1.BlockType.ListItem:
            var data = {
                level: token.level,
                listType: token.listType,
            };
            if (token.startCounter != null) {
                data.startCounter = token.startCounter;
            }
            currentBlock.data = data;
            break;
        case Common_1.BlockType.HorizontalRule:
            currentBlock = createHorizontalRuleNode(token, commentTracker);
            break;
        case Common_1.BlockType.GoogleMaps:
            currentBlock = createGoogleMapsNode(token, commentTracker);
            break;
        case Common_1.BlockType.Iframe:
            currentBlock = createIframeNode(token, commentTracker);
            break;
        case Common_1.BlockType.Image:
            currentBlock = createImageNode(token, commentTracker);
            break;
        case Common_1.BlockType.MediaVariable:
            if (token.media === MediaVariable_1.Media.Image) {
                currentBlock = createImageNode(token, commentTracker);
            }
            else if (token.media === MediaVariable_1.Media.Video) {
                currentBlock = createVideoNode(token, commentTracker);
            }
            else if (token.media === MediaVariable_1.Media.GoogleMaps) {
                currentBlock = createGoogleMapsNode(token, commentTracker);
            }
            else if (token.media === MediaVariable_1.Media.Iframe) {
                currentBlock = createIframeNode(token, commentTracker);
            }
            break;
        case Common_1.BlockType.Video:
            currentBlock = createVideoNode(token, commentTracker);
            break;
        case Common_1.BlockType.Table:
            currentBlock = createTableNode(token, content, commentTracker);
            break;
        case Common_1.BlockType.SideBySide:
            currentBlock = createSideBySideNode(token, content, commentTracker);
            break;
        case Common_1.BlockType.Button:
            currentBlock = createButtonNode(token, commentTracker);
            break;
        case Common_1.BlockType.ROICalculator:
            currentBlock = createROICalculatorNode(token, commentTracker);
            break;
        case Common_1.BlockType.ContentLoop:
            currentBlock = createContentLoopNode(token, commentTracker);
            break;
        case Common_1.BlockType.Accordion:
            currentBlock = createAccordionNode(token, content, commentTracker);
            break;
        default:
            console.error(new Error("unrecognised block type: ".concat(token.subType)));
            return null;
    }
    return currentBlock;
};
exports.processBlock = processBlock;
var processInline = function (token, commentTracker) {
    if (token.subType == Common_1.InlineType.LineBreak) {
        return createBreakNode(token, commentTracker);
    }
    else if (token != null && token.subType === Common_1.InlineType.Variable) {
        return (0, exports.createVariableNode)(token, commentTracker);
    }
    else if (token != null && token.href != null) {
        return createLinkNode(token, commentTracker);
    }
    else {
        return createTextNode(token, commentTracker);
    }
};
exports.processInline = processInline;
var processSelection = function (token, content, lastNode, currentBlock, nextToken) {
    if (!content.selection) {
        content.selection = {
            anchor: {},
            focus: {},
        };
    }
    if (!lastNode) {
        throw new Error("invalid token set");
    }
    if (lastNode.isVoid) {
        lastNode = lastNode.children[0];
    }
    var lastNodeIsComplexWidget = [Common_1.BlockType.SideBySide, Common_1.BlockType.Table, Common_1.BlockType.Accordion].includes(lastNode.type);
    if (lastNodeIsComplexWidget) {
        lastNode = lastNode.children[0].children[0];
    }
    if (!content.selection) {
        throw new Error("Selection should have been defined by now");
    }
    if (token.subType === "anchor" || token.subType === "focus") {
        var location = token.subType;
        lastNode.key = token.subType;
        var path = getPath(token.subType, content.children.concat(currentBlock)) || [];
        var offset = calculateOffset(lastNode);
        if ((0, Utils_1.isInline)(lastNode) && lastNode.type === Common_1.InlineType.Link) {
            path.push(lastNode.children.length - 1);
        }
        else if ((0, Utils_1.isInline)(lastNode)) {
            path.push(0);
        }
        else if ((0, Utils_1.isBlockElement)(lastNode)) {
            path.push(0);
            if (nextToken.type == "inline" && (nextToken.subType !== "text" || nextToken.href != undefined)) {
                path.push(0);
            }
        }
        content.selection[location].path = path;
        content.selection[location].offset = offset;
        delete lastNode.key;
    }
    else {
        throw new Error("Unknown selection subtype");
    }
};
exports.processSelection = processSelection;
var calculateOffset = function (lastNode) {
    if ((0, Utils_1.isBlockElement)(lastNode)) {
        return 0;
    }
    else if (Text_1.Text.isText(lastNode)) {
        return lastNode.text.length;
    }
    else if ((0, Utils_1.isInline)(lastNode)) {
        var offset = calculateOffset(lastNode.children[lastNode.children.length - 1]);
        return offset;
    }
    else {
        throw new Error("Trying to calculate offset for unknown node");
    }
};
var createVariableNode = function (persistedToken, commentTracker, isVoid) {
    if (isVoid === void 0) { isVoid = true; }
    var slateNode = {
        type: Common_1.InlineType.Variable,
        isVoid: isVoid,
        data: {
            variableName: persistedToken.name,
            variableLabel: persistedToken.label,
            isBold: persistedToken.isBold,
            isItalic: persistedToken.isItalic,
            isStrikethrough: persistedToken.isStrikethrough,
            providerType: persistedToken.providerType,
        },
        children: [createEmptyTextNode()],
    };
    if (persistedToken.substitutionToken) {
        slateNode.data.substitutionToken = persistedToken.substitutionToken;
    }
    return slateNode;
};
exports.createVariableNode = createVariableNode;
var createLinkNode = function (token, commentTracker) {
    return {
        type: Common_1.InlineType.Link,
        data: {
            href: token.href,
        },
        children: [createTextNode(token, commentTracker)],
    };
};
var createBreakNode = function (token, commentTracker) {
    return {
        type: "lineBreak",
        isVoid: true,
        data: {},
        children: [createEmptyTextNode()],
    };
};
var createTextNode = function (token, commentTracker) {
    var textNode = {
        text: token.content,
        marks: getTokenMarks(token, commentTracker),
    };
    return textNode;
};
var createEmptyTextNode = function () {
    return { text: "", marks: [] };
};
var createImageNode = function (persistedToken, commentTracker) {
    var node = {
        type: Common_1.BlockType.Image,
        isVoid: true,
        data: {
            src: persistedToken.src || "",
            width: persistedToken.width,
        },
        children: [createEmptyTextNode()],
    };
    if (persistedToken.href) {
        node.data.href = persistedToken.href;
    }
    if (persistedToken.alt) {
        node.data.alt = persistedToken.alt.value;
    }
    if (persistedToken.role) {
        node.data.role = persistedToken.role;
    }
    if (persistedToken.alignment) {
        node.data.alignment = persistedToken.alignment;
    }
    if (persistedToken.frame) {
        node.data.frame = persistedToken.frame;
    }
    if (persistedToken.aspectRatio) {
        node.data.aspectRatio = persistedToken.aspectRatio;
    }
    if (persistedToken.uploadId) {
        node.data.uploadId = persistedToken.uploadId;
    }
    if (persistedToken.subType === Common_1.BlockType.Image) {
        if (persistedToken.scale) {
            node.data.scale = persistedToken.scale;
        }
        if (persistedToken.translation) {
            node.data.translation = persistedToken.translation;
        }
    }
    else if (persistedToken.subType === Common_1.BlockType.MediaVariable) {
        node.data.variable = {
            name: persistedToken.name,
            label: persistedToken.label,
        };
        if (persistedToken.substitutionToken) {
            node.data.variable.substitutionToken = persistedToken.substitutionToken;
        }
    }
    return node;
};
var createGoogleMapsNode = function (persistedToken, commentTracker) {
    var node = {
        type: Common_1.BlockType.GoogleMaps,
        isVoid: true,
        data: {},
        children: [createEmptyTextNode()],
    };
    if (persistedToken.width) {
        node.data.width = persistedToken.width;
    }
    if (persistedToken.subType === Common_1.BlockType.GoogleMaps) {
        if (persistedToken.displayUrl) {
            node.data.displayUrl = persistedToken.displayUrl;
        }
        if (persistedToken.embedUrl) {
            node.data.embedUrl = persistedToken.embedUrl;
        }
    }
    else if (persistedToken.subType === Common_1.BlockType.MediaVariable) {
        node.data.variable = {
            name: persistedToken.name,
            label: persistedToken.label,
        };
        if (persistedToken.substitutionToken) {
            node.data.variable.substitutionToken = persistedToken.substitutionToken;
        }
    }
    return node;
};
var createIframeNode = function (persistedToken, commentTracker) {
    var node = {
        type: Common_1.BlockType.Iframe,
        isVoid: true,
        data: {},
        children: [createEmptyTextNode()],
    };
    if (persistedToken.width) {
        node.data.width = persistedToken.width;
    }
    if (persistedToken.height) {
        node.data.height = persistedToken.height;
    }
    if (persistedToken.embedPreset) {
        node.data.embedPreset = persistedToken.embedPreset;
    }
    else {
        node.data.embedPreset = "iframe";
    }
    if (persistedToken.alignment) {
        node.data.alignment = persistedToken.alignment;
    }
    else {
        node.data.alignment = "center";
    }
    if (persistedToken.subType === Common_1.BlockType.Iframe) {
        if (persistedToken.embedUrl) {
            node.data.embedUrl = persistedToken.embedUrl;
        }
    }
    else if (persistedToken.subType === Common_1.BlockType.MediaVariable) {
        node.data.variable = {
            name: persistedToken.name,
            label: persistedToken.label,
        };
        if (persistedToken.substitutionToken) {
            node.data.variable.substitutionToken = persistedToken.substitutionToken;
        }
    }
    return node;
};
var createVideoNode = function (persistedToken, commentTracker) {
    var node = {
        type: Common_1.BlockType.Video,
        isVoid: true,
        data: {
            displayUrl: "",
        },
        children: [createEmptyTextNode()],
    };
    if (persistedToken.width) {
        node.data.width = persistedToken.width;
    }
    if (persistedToken.subType === Common_1.BlockType.Video) {
        if (persistedToken.displayUrl) {
            node.data.displayUrl = persistedToken.displayUrl;
        }
        if (persistedToken.embedUrl) {
            node.data.embedUrl = persistedToken.embedUrl;
        }
    }
    else if (persistedToken.subType === Common_1.BlockType.MediaVariable) {
        node.data.variable = {
            name: persistedToken.name,
            label: persistedToken.label,
        };
        if (persistedToken.substitutionToken) {
            node.data.variable.substitutionToken = persistedToken.substitutionToken;
        }
    }
    return node;
};
var createROICalculatorNode = function (token, commentTracker) {
    var _a;
    var node = {
        type: Common_1.BlockType.ROICalculator,
        isVoid: true,
        data: {
            slider: token.slider,
            inputs: (_a = token.inputs) !== null && _a !== void 0 ? _a : {},
            roiResult: token.roiResult,
            title: token.title,
            description: token.description,
            variableCounter: token.variableCounter,
            backgroundImageUrl: token.backgroundImageUrl,
            hasSelectedPreset: token.hasSelectedPreset,
        },
        children: [createEmptyTextNode()],
    };
    return node;
};
var createButtonNode = function (token, commentTracker) {
    var node = {
        type: Common_1.BlockType.Button,
        isVoid: true,
        data: {
            href: token.href,
            text: token.text,
            alignment: token.alignment,
        },
        children: [createEmptyTextNode()],
    };
    return node;
};
var createContentLoopNode = function (token, commentTracker) {
    var contentLoopNodesAndSelection = (0, exports.deserialiseNode)(token.content, commentTracker);
    return ContentLoop_1.contentLoop.createSlateJson(contentLoopNodesAndSelection.children, token.variable);
};
var createHorizontalRuleNode = function (token, commentTracker) {
    return {
        type: Common_1.BlockType.HorizontalRule,
        isVoid: true,
        children: [createEmptyTextNode()],
    };
};
var createTableNode = function (token, content, commentTracker) {
    var tableNode = {
        type: Common_1.BlockType.Table,
        isVoid: false,
        data: {
            rows: token.cells.length,
            columns: token.cells[0].length,
            columnBorders: token.columnBorders,
            selection: token.selection,
        },
        children: [
            {
                type: Common_1.BlockType.TableDummy,
                isVoid: true,
                children: [createEmptyTextNode()],
            },
        ],
    };
    var currRowNum = 1;
    var _loop_1 = function (i) {
        var e_1, _a;
        var row = token.cells[i];
        var repeatingRow = token.repeatingRows && token.repeatingRows.find(function (repeatingRow) { return repeatingRow.rowIndex === i; });
        var rowElement = repeatingRow
            ? (0, Table_1.createEmptyTableRepeatingRowNode)(repeatingRow.repeatingToken)
            : (0, Table_1.createEmptyTableRowNode)();
        var currentCellNum = 0;
        try {
            for (var row_1 = (e_1 = void 0, __values(row)), row_1_1 = row_1.next(); !row_1_1.done; row_1_1 = row_1.next()) {
                var cell = row_1_1.value;
                var cellContent = void 0;
                if (cell.length === 0) {
                    cellContent = createEmptyParagraphContent();
                }
                else {
                    cellContent = (0, exports.deserialiseNode)(cell, commentTracker);
                }
                var cellNode = {
                    type: Common_1.BlockType.TableCell,
                    isVoid: false,
                    data: {},
                    children: cellContent.children,
                };
                rowElement.children.push(cellNode);
                if (cellContent.selection) {
                    tableNode.key = "tempTableKey";
                    var tablePath = getPath(tableNode.key, content.children.concat(tableNode));
                    if (cellContent.selection.anchor.path) {
                        cellContent.selection.anchor.path = tablePath.concat([currRowNum, currentCellNum], cellContent.selection.anchor.path);
                    }
                    if (cellContent.selection.focus.path) {
                        cellContent.selection.focus.path = tablePath.concat([currRowNum, currentCellNum], cellContent.selection.focus.path);
                    }
                    if (content.selection) {
                        if (content.selection.anchor.path) {
                            content.selection.focus = cellContent.selection.focus;
                        }
                        else {
                            content.selection.anchor = cellContent.selection.anchor;
                            content.selection.isBackward = true;
                        }
                    }
                    else {
                        content.selection = cellContent.selection;
                    }
                    delete tableNode.key;
                }
                currentCellNum++;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (row_1_1 && !row_1_1.done && (_a = row_1.return)) _a.call(row_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        tableNode.children.push(rowElement);
        currRowNum++;
    };
    for (var i = 0; i < token.cells.length; i++) {
        _loop_1(i);
    }
    return tableNode;
};
var getPlaceholderIndex = function (order, renderPlaceholder, placeholderIndex) {
    if (!order) {
        return placeholderIndex;
    }
    if (!renderPlaceholder) {
        return null;
    }
    return order === SideBySide_1.SideBySideOrder.Normal ? SideBySide_2.SideBySidePlaceholderIndex.Column2 : SideBySide_2.SideBySidePlaceholderIndex.Column1;
};
var createSideBySideNode = function (token, content, commentTracker) {
    var e_2, _a;
    var _b;
    var placeholderIndex = getPlaceholderIndex(token.order, token.renderPlaceholder, token.placeholderIndex);
    var width = token.width === SideBySide_2.SideBySideWidth.Normal ? SideBySide_2.SideBySideWidth.Wide : token.width;
    var sideBySideNode = {
        type: Common_1.BlockType.SideBySide,
        isVoid: false,
        data: {
            width: width,
            percent: token.percent,
            alignment: token.alignment,
            selectedColumns: [],
            selection: null,
            placeholderIndex: placeholderIndex,
        },
        children: [
            {
                type: Common_1.BlockType.SideBySideDummy,
                data: {},
                isVoid: true,
                children: [createEmptyTextNode()],
            },
        ],
    };
    var columnNum = 0;
    var columns = ((_b = token.order) !== null && _b !== void 0 ? _b : SideBySide_1.SideBySideOrder.Normal) === SideBySide_1.SideBySideOrder.Normal
        ? [token.column1, token.column2]
        : [token.column2, token.column1];
    try {
        for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
            var column = columns_1_1.value;
            columnNum++;
            var columnContent = void 0;
            if (column && column.length === 0) {
                columnContent = createEmptyParagraphContent();
            }
            else {
                columnContent = (0, exports.deserialiseNode)(column, commentTracker);
            }
            var columnNode = {
                type: Common_1.BlockType.SideBySideColumn,
                isVoid: false,
                data: {},
                children: columnContent.children,
            };
            sideBySideNode.children.push(columnNode);
            if (columnContent.selection) {
                sideBySideNode.key = "tempSideBySideKey";
                var sideBySidePath = getPath(sideBySideNode.key, content.children.concat(sideBySideNode));
                if (columnContent.selection.anchor.path) {
                    columnContent.selection.anchor.path = sideBySidePath.concat([columnNum], columnContent.selection.anchor.path);
                }
                if (columnContent.selection.focus.path) {
                    columnContent.selection.focus.path = sideBySidePath.concat([columnNum], columnContent.selection.focus.path);
                }
                if (content.selection) {
                    if (content.selection.anchor.path) {
                        content.selection.focus = columnContent.selection.focus;
                    }
                    else {
                        content.selection.anchor = columnContent.selection.anchor;
                        content.selection.isBackward = true;
                    }
                }
                else {
                    content.selection = columnContent.selection;
                }
                delete sideBySideNode.key;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return sideBySideNode;
};
var getTokenMarks = function (token, commentTracker) {
    if (commentTracker === void 0) { commentTracker = {}; }
    var marks = [];
    if (token.style) {
        if (token.style.bold) {
            marks.push({ data: {}, type: "bold" });
        }
        if (token.style.italic) {
            marks.push({ data: {}, type: "italic" });
        }
        if (token.style.strikethrough) {
            marks.push({ data: {}, type: "strikethrough" });
        }
    }
    Object.values(commentTracker).forEach(function (comment) {
        marks.push({ data: { id: comment.id }, type: "comment" });
    });
    return marks;
};
var nodesCanMerge = function (a, b) {
    if (!a || !b || getNodeObject(a) != getNodeObject(b)) {
        return false;
    }
    switch (getNodeObject(a)) {
        case "block":
            return false;
        case "inline":
            if (a.type === Common_1.InlineType.Variable || b.type === Common_1.InlineType.Variable) {
                return false;
            }
            if (a.type === Common_1.InlineType.Link && a.type === b.type) {
                return a.data.href === b.data.href;
            }
            return false;
        case "text":
            return (0, lodash_1.isEqual)(a.marks, b.marks);
        default:
            throw new Error("Trying to match unknown node object types");
    }
};
var mergeNodeInto = function (baseNode, otherNode) {
    switch (getNodeObject(baseNode)) {
        case "block":
            throw new Error("Cannot merge block nodes");
        case "inline":
            mergeInline(baseNode, otherNode);
            return;
        case "text":
            baseNode.text = baseNode.text + otherNode.text;
            return;
        default:
            throw new Error("Trying to merge unknown node object types");
    }
};
var getPath = function (key, value) {
    for (var i = 0; i < value.length; i++) {
        var node = value[i];
        if (node.key == key) {
            return [i];
        }
        if (node.children && node.children.length > 0) {
            var maybePath = getPath(key, node.children);
            if (maybePath) {
                return [i].concat(maybePath);
            }
        }
    }
    return null;
};
var getNodeObject = function (node) {
    if (Text_1.Text.isText(node)) {
        return "text";
    }
    else if ((0, Utils_1.isInline)(node)) {
        return "inline";
    }
    else {
        return "block";
    }
};
var mergeInline = function (baseNode, otherNode) {
    var e_3, _a;
    var prevChild = baseNode.children[baseNode.children.length - 1];
    try {
        for (var _b = __values(otherNode.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            if (nodesCanMerge(prevChild, child)) {
                prevChild.text = prevChild.text + child.text;
            }
            else {
                prevChild = child;
                baseNode.children.push(child);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
};
var createEmptyParagraphContent = function () {
    return {
        children: [
            {
                type: Common_1.BlockType.Paragraph,
                children: [createEmptyTextNode()],
                data: {},
                isVoid: false,
            },
        ],
    };
};
var createAccordionNode = function (token, content, commentTracker) {
    var accordionDummyNode = {
        type: Common_1.BlockType.AccordionDummy,
        isVoid: true,
        children: [createEmptyTextNode()],
    };
    var bodyContent;
    if (token.body && token.body.length === 0) {
        (0, DeserialiseErrorRecorder_1.sendEmptyAccordionBodyToSentry)({});
        bodyContent = createEmptyParagraphContent();
    }
    else {
        bodyContent = (0, exports.deserialiseNode)(token.body, commentTracker);
    }
    var accordionBodyNode = {
        type: Common_1.BlockType.AccordionBody,
        isVoid: false,
        data: {},
        children: bodyContent.children,
    };
    var headingContent = (0, exports.deserialiseNode)(token.heading, commentTracker);
    var accordionHeadingNode = {
        type: Common_1.BlockType.AccordionHeading,
        isVoid: false,
        data: {},
        children: headingContent.children,
    };
    var node = {
        type: Common_1.BlockType.Accordion,
        isVoid: false,
        data: { expanded: false, backgroundImageUrl: token.backgroundImageUrl },
        children: [accordionDummyNode, accordionHeadingNode, accordionBodyNode],
    };
    var extractSelectionFromChild = function (index, areaContent) {
        if (areaContent.selection) {
            node.key = "tempAccordionKey";
            var accordionPath = getPath(node.key, content.children.concat(node));
            if (areaContent.selection.anchor.path) {
                areaContent.selection.anchor.path = accordionPath.concat([index], areaContent.selection.anchor.path);
            }
            if (areaContent.selection.focus.path) {
                areaContent.selection.focus.path = accordionPath.concat([index], areaContent.selection.focus.path);
            }
            if (content.selection) {
                if (content.selection.anchor.path) {
                    content.selection.focus = areaContent.selection.focus;
                }
                else {
                    content.selection.anchor = areaContent.selection.anchor;
                    content.selection.isBackward = true;
                }
            }
            else {
                content.selection = areaContent.selection;
            }
            delete node.key;
        }
    };
    extractSelectionFromChild(1, headingContent);
    extractSelectionFromChild(2, bodyContent);
    return node;
};
